import { Icons, ChakraButton as Button } from "@airhelp/react-ui-components";
import { arrowColor } from "../utility/styleConsts";
import type { NextButtonProps } from "./NextButton.d";

const NextButton = ({ nextPage, canNextPage }: NextButtonProps) => (
  <Button
    aria-label="next"
    variant="unstyled"
    onClick={nextPage}
    isDisabled={!canNextPage}
    color={arrowColor(canNextPage)}
    display="flex"
    alignItems="center"
    minWidth={{ base: 8, md: 10 }}
    minHeight={{ base: 8, md: 10 }}
    sx={{ svg: { boxSize: { base: 4, md: 5 } } }}
  >
    <Icons.ArrowRight />
  </Button>
);

export default NextButton;
